(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ba]').forEach(function (fig) {
    var stage = fig.querySelector('[data-ba-stage]');
    var range = fig.querySelector('[data-ba-range]');
    var set = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      fig.style.setProperty('--pos', pct + '%');
      if (String(Math.round(pct)) !== range.value) range.value = Math.round(pct);
    };
    var fromEvent = function (e) {
      var r = stage.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    };
    var dragging = false, nudge = null;
    var touched = function () { fig.classList.add('is-touched'); fig.classList.remove('is-nudging'); if (nudge) { cancelAnimationFrame(nudge); nudge = null; } };
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      touched(); dragging = true; stage.setPointerCapture(e.pointerId); fromEvent(e); e.preventDefault();
    });
    range.addEventListener('focus', touched);
    // one-time nudge when the slider scrolls into view: glide the divider left and back so it reads as a control
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || fig.classList.contains('is-touched')) return;
        io.disconnect(); fig.classList.add('is-nudging');
        var start = parseFloat(range.value) || 50, t0 = null, D = 1600;
        var ease = function (x) { return 0.5 - 0.5 * Math.cos(Math.PI * x); };
        var step = function (ts) {
          if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / D);
          var off = k < 0.5 ? ease(k / 0.5) : ease((1 - k) / 0.5);      // out to -16% and back
          set(start - 16 * off);
          if (k < 1 && fig.classList.contains('is-nudging')) nudge = requestAnimationFrame(step); else nudge = null;
        };
        setTimeout(function () { if (!fig.classList.contains('is-touched')) nudge = requestAnimationFrame(step); }, 500);
      }, { threshold: 0.6 });
      io.observe(stage);
    }
    stage.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    var stop = function () { dragging = false; };
    stage.addEventListener('pointerup', stop); stage.addEventListener('pointercancel', stop);
    range.addEventListener('input', function () { set(parseFloat(range.value)); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["commission-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('.lp-coverage').forEach(function (coverage) {
      if (coverage.dataset.proofReady) return;
      coverage.dataset.proofReady = 'true';
      var track = coverage.querySelector('.lp-proof-track');
      var cards = Array.from(track.children);
      var previous = coverage.querySelector('[data-proof-prev]');
      var next = coverage.querySelector('[data-proof-next]');
      var count = coverage.querySelector('[data-proof-count]');
      coverage.querySelector('.lp-proof-controls').hidden = false;
      function update() {
        var box = track.getBoundingClientRect();
        var visible = cards.map(function (card, i) { var r = card.getBoundingClientRect(); return r.left >= box.left - 4 && r.right <= box.right + 4 ? i + 1 : 0; }).filter(Boolean);
        if (visible.length) count.textContent = visible[0] + (visible.length > 1 ? '–' + visible[visible.length - 1] : '') + ' / ' + cards.length;
        previous.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      function move(direction) {
        var distance = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('keydown', function (event) { if (event.target === track && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } });
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Mirror the chosen configuration under the pills so the selection reads at a glance.
  (function () {
    var form = document.querySelector("form[data-product-form]");
    // Gallery: drive the scroll-snap carousel from the thumbnails with JS.
    // The anchor fallback (#pdp-slide-N) makes iOS scroll INSIDE the overflow-hidden
    // viewer as well as horizontally, shifting the slide up/right and clipping the watch.
    (function () {
      var slides = document.querySelector('.pdp-slides');
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb'));
      if (!slides || !thumbs.length) return;
      var setActive = function (i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); };
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          slides.scrollTo({ left: i * slides.clientWidth, top: 0, behavior: 'smooth' });
          setActive(i);
        });
      });
      var raf;
      slides.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); });
      }, { passive: true });
      // if the page loads with a slide hash, realign the viewer instead of leaving it offset
      if (/^#pdp-slide-\d+$/.test(location.hash)) {
        var n = parseInt(location.hash.replace('#pdp-slide-', ''), 10) - 1;
        requestAnimationFrame(function () { slides.scrollTo({ left: n * slides.clientWidth, top: 0 }); document.querySelector('.pdp-main').scrollTop = 0; setActive(n); });
      }
    })();

    // Direct-purchase variants (for example gift-card denominations) update the displayed price.
    var variantSelect = form && form.querySelector('select[name="id"]');
    if (variantSelect) variantSelect.addEventListener('change', function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var price = document.querySelector('[data-price]');
      if (price && selected) price.textContent = selected.getAttribute('data-display-price');
    });
    var summary = document.querySelector("[data-config-summary]");
    if (!form || !summary) return;
    function update() {
      var parts = [];
      form.querySelectorAll('.cfg-opts input[type="radio"]:checked').forEach(function (el) { parts.push(el.value); });
      // multi-select groups: join picks into the hidden line-item property
      form.querySelectorAll('[data-multi-target]').forEach(function (hidden) {
        var picks = [];
        form.querySelectorAll('input[data-multi="' + hidden.getAttribute('data-multi-target') + '"]:checked').forEach(function (el) { picks.push(el.value); });
        hidden.value = picks.join(', ');
        if (picks.length) parts.push(picks.join(' + '));
      });
      var review = summary.querySelector('[data-config-review]');
      if (review) {
        review.replaceChildren();
        form.querySelectorAll('[data-cfg-group]').forEach(function (group) {
          var values = Array.from(group.querySelectorAll('input:checked:not(:disabled)')).map(function (input) { return input.value; });
          var row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
          label.textContent = group.dataset.stepTitle || group.dataset.cfgGroup;
          value.textContent = values.length ? values.join(', ') : review.dataset.emptyLabel;
          row.append(label, value); review.appendChild(row);
        });
        summary.hidden = false;
      }
    }
    // ---- option rules and price add-ons (see snippets/pdp-option.liquid for the [tag] syntax) ----
    var moneyFmt = form.getAttribute('data-money-format') || ('$' + '\x7b\x7bamount\x7d\x7d');
    var basePrice = parseInt(form.getAttribute('data-base-price') || '0', 10), deposit = parseInt(form.getAttribute('data-deposit') || '0', 10);
    function money(cents) {
      var n = cents / 100, s;
      if (/amount_no_decimals/.test(moneyFmt)) s = Math.round(n).toLocaleString('en-CA');
      else if (/amount_with_comma_separator/.test(moneyFmt)) s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      else s = n.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFmt.replace(/\x7b\x7b\s*amount[a-z_]*\s*\x7d\x7d/, s).replace(/<[^>]+>/g, '');
    }
    function picks(group) {
      var out = [];
      form.querySelectorAll('[data-cfg-group="' + group + '"] input:checked').forEach(function (i) { out.push(i.value.toLowerCase()); });
      return out;
    }
    function hit(group, terms) {
      var vals = picks(group);
      return terms.some(function (t) { t = t.trim().toLowerCase(); return t && vals.some(function (v) { return v.indexOf(t) !== -1; }); });
    }
    function evalRules() {
      var changed = false;
      form.querySelectorAll('.cfg-opt').forEach(function (lab) {
        var input = lab.querySelector('input'), why = lab.querySelector('[data-why]'), ok = true, reason = '';
        (lab.getAttribute('data-rules') || '').split(';').forEach(function (rule) {
          var m = rule.match(/^\s*(only|not|needs)\s+([^:]+):\s*(.+)$/i); if (!m || !ok) return;
          var kind = m[1].toLowerCase(), group = m[2].trim(), terms = m[3].split(','), h = hit(group, terms);
          if (kind === 'only' && !h) { ok = false; reason = 'Only with ' + terms.map(function (t) { return t.trim(); }).join(' or ') + ' ' + group.toLowerCase(); }
          if (kind === 'not' && h) { ok = false; reason = 'Not with a ' + terms.map(function (t) { return t.trim(); }).join(' or ') + ' ' + group.toLowerCase(); }
          if (kind === 'needs' && !h) { ok = false; reason = 'Needs ' + terms.map(function (t) { return t.trim(); }).join(' + '); }
        });
        if (/custom date disc/i.test(input.value) && !hit('Complication', ['NH35', 'NH36', 'NH34', '6R35'])) { ok = false; reason = 'Requires a movement with a date display'; }
        if (/custom day/i.test(input.value) && !hit('Complication', ['NH36'])) { ok = false; reason = 'Requires the NH36 day-and-date movement'; }
        input.disabled = !ok; lab.classList.toggle('is-off', !ok);
        if (why) { why.textContent = ok ? '' : reason; why.hidden = ok; }
        if (!ok && input.checked) {
          input.checked = false; changed = true;
          if (input.type === 'radio') { var alt = form.querySelector('[data-cfg-group="' + lab.closest('[data-cfg-group]').getAttribute('data-cfg-group') + '"] input:not(:disabled)'); if (alt) alt.checked = true; }
        }
      });
      return changed;
    }
    function price() {
      var total = basePrice;
      form.querySelectorAll('.cfg-opts input:checked[data-delta-cents]').forEach(function (i) { total += parseInt(i.getAttribute('data-delta-cents'), 10) || 0; });
      var est = form.querySelector('input[name="properties[Estimated total]"]'); if (est) est.value = money(total) + ' ' + form.getAttribute('data-currency');
      document.querySelectorAll('[data-price], [data-est]').forEach(function (el) { el.textContent = money(total); });
      var bal = document.querySelector('[data-balance]'); if (bal) bal.textContent = money(Math.max(total - deposit, 0));
    }
    function refresh() { for (var i = 0; i < 3 && evalRules(); i++) {} update(); price(); }
    var handle = form.getAttribute('data-build-handle');
    var presets = {
      'abyss-professional': { 'Strap': ['FKM rubber'], 'Optional extras': ['Premium ratcheting clasp', 'Custom date disc', 'Sapphire caseback', 'Decorated rotor'] },
      'blk-carbon-series': { 'Strap': ['FKM rubber'], 'Optional extras': ['Premium ratcheting clasp', 'Custom date disc', 'Decorated rotor'] },
      'sam-sktl-series': { 'Case finish': ['Grade 5 titanium'], 'Bezel': ['Coloured steel'], 'Strap': ['FKM rubber'] },
      'mosaic-pearlmaster': { 'Strap': ['Premium 316L SS bracelet'] },
      'carbon-case-series': { 'Strap': ['20mm forged carbon bracelet'] }
    };
    Object.keys(presets[handle] || {}).forEach(function (group) {
      form.querySelectorAll('[data-cfg-group="' + group + '"] input:not([type="hidden"])').forEach(function (input) {
        input.checked = presets[handle][group].some(function (prefix) { return input.value.indexOf(prefix) === 0; });
      });
    });
    if (handle === 'blk-carbon-series') form.querySelectorAll('[data-cfg-group="Optional extras"] .cfg-opt').forEach(function (lab) {
      if (/^Decorated rotor/.test(lab.querySelector('input').value)) lab.removeAttribute('data-rules');
    });
    // Match the landing-page question rows: current pick, Change/Done, pointer-only single-choice folding.
    var guide = form.querySelector('#watch-options'), steps = Array.from(form.querySelectorAll('[data-config-step]'));
    function stepPicks(step) { return Array.from(step.querySelectorAll('input:checked:not(:disabled)')).map(function (i) { return i.value; }); }
    function foldStep(step, open) {
      clearTimeout(step._foldTimer);
      step.classList.toggle('is-collapsed', !open);
      var panel = step.querySelector('[data-step-panel]'), button = step.querySelector('[data-step-toggle]');
      panel.hidden = !open; button.setAttribute('aria-expanded', String(open));
      var label = open ? guide.dataset.stepDone : guide.dataset.stepChange;
      button.textContent = label; button.setAttribute('aria-label', label + ' — ' + step.dataset.stepTitle);
    }
    function updateSteps() { steps.forEach(function (step) { var values = stepPicks(step); step.querySelector('[data-step-current]').textContent = values.length ? values.join(' + ') : form.querySelector('[data-config-review]').dataset.emptyLabel; }); }
    steps.forEach(function (step, index) {
      step.querySelector('[data-step-number]').textContent = String(index + 1).padStart(2, '0');
      foldStep(step, false);
      step.querySelector('[data-step-toggle]').addEventListener('click', function (event) {
        var open = step.classList.contains('is-collapsed'); foldStep(step, open);
        if (open && event.detail === 0) { var input = step.querySelector('input:checked:not(:disabled)') || step.querySelector('input:not(:disabled)'); if(input) input.focus({preventScroll:true}); }
      });
      step.addEventListener('click', function (event) {
        var label = event.target.closest('.cfg-opt'); if (!label || event.detail === 0) return;
        var radio = label.querySelector('input[type="radio"]'); if (!radio || radio.disabled) return;
        clearTimeout(step._foldTimer); step._foldTimer = setTimeout(function () { if (step.contains(document.activeElement)) step.querySelector('[data-step-toggle]').focus({preventScroll:true}); foldStep(step, false); }, 320);
      });
    });
    // Progressive disclosure retains inputs in the form, so collapsing never resets a build.
    var editor = form.querySelector('[data-config-editor]');
    var editLink = document.querySelector('.pdp-purchase-actions a[href="#watch-options"]');
    function openEditor(scroll) {
      if (!editor) return;
      editor.open = true;
      if (scroll) { editor.querySelector('summary').focus({preventScroll:true}); editor.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); }
    }
    if (editLink) editLink.addEventListener('click', function (event) { event.preventDefault(); openEditor(true); });
    var done = form.querySelector('[data-config-done]');
    if (done) done.addEventListener('click', function () {
      editor.open = false; steps.forEach(function(step){foldStep(step,false);}); summary.open = true; editor.querySelector('summary').focus({preventScroll:true});
      summary.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
    function revealHash() { if (location.hash === '#watch-options') openEditor(true); }
    window.addEventListener('hashchange', revealHash); revealHash();
    var delivery = document.getElementById('watch-delivery');
    function revealDelivery() { if (delivery && location.hash === '#watch-delivery') { delivery.open = true; delivery.querySelector('summary').focus({preventScroll:true}); } }
    document.querySelectorAll('a[href="#watch-delivery"]').forEach(function (link) { link.addEventListener('click', function () { if(delivery) delivery.open = true; }); });
    window.addEventListener('hashchange', revealDelivery); revealDelivery();
    form.addEventListener("change", function () { refresh(); updateSteps(); });
    refresh(); updateSteps();
  })();

  // Sticky purchase bar: show while the in-page buy button is out of view.
  (function () {
    var bar = document.querySelector("[data-stickybar]");
    var buy = document.querySelector("[data-buy-area]");
    if (!bar || !buy || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible) { bar.setAttribute("hidden", ""); } else { bar.removeAttribute("hidden"); }
    }, { rootMargin: "-60px 0px 0px 0px" });
    io.observe(buy);
  })();
  // Keep the phone chat launcher clear of purchase controls while they are visible.
  (function () {
    var targets = document.querySelectorAll('[data-purchase-entry], [data-buy-area], [data-config-editor]');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
      document.documentElement.classList.toggle('nhl-pdp-purchase-active', visible.size > 0);
    });
    targets.forEach(function (target) { observer.observe(target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meteorite-landing-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.galleryReady) return;
    var viewport = gallery.querySelector('[data-gallery-viewport]');
    if (!viewport) return;
    gallery.dataset.galleryReady = 'true';
    var slides = Array.from(viewport.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    var strip = gallery.querySelector('[data-gallery-thumbnails]');
    var previous = gallery.querySelector('[data-gallery-previous]');
    var next = gallery.querySelector('[data-gallery-next]');
    var position = gallery.querySelector('[data-gallery-position]');
    var active = -1, frame = 0;
    function sync() {
      frame = 0;
      var width = viewport.clientWidth;
      if (!width) return;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / width)));
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (index === active) return;
      active = index;
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === index)); });
      if (position) position.textContent = gallery.dataset.galleryCountPattern.replace('__CURRENT__', String(index + 1));
      var thumb = thumbs[index];
      if (strip && thumb) {
        var t = thumb.getBoundingClientRect(), r = strip.getBoundingClientRect();
        if (t.left < r.left || t.right > r.right) strip.scrollTo({left: strip.scrollLeft + t.left - r.left - (r.width - t.width) / 2, behavior: 'auto'});
      }
    }
    function go(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      viewport.scrollTo({left: index * viewport.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function (event) { event.preventDefault(); go(i); }); });
    if (previous) { previous.hidden = false; previous.addEventListener('click', function () { go(active - 1); }); }
    if (next) { next.hidden = false; next.addEventListener('click', function () { go(active + 1); }); }
    viewport.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(sync); }, {passive:true});
    viewport.addEventListener('keydown', function (event) {
      if (event.target !== viewport) return;
      var index;
      if (event.key === 'ArrowRight') index = active + 1;
      else if (event.key === 'ArrowLeft') index = active - 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = slides.length - 1;
      else return;
      event.preventDefault(); go(index);
    });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (active >= 0) viewport.scrollTo({left: active * viewport.clientWidth, behavior:'instant'}); sync(); }).observe(viewport);
    sync();
  }
  function init(root) {
    root.querySelectorAll('[data-watch-gallery]').forEach(initGallery);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["platform-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-clamp-toggle]').forEach(function (btn) {
    var body = btn.previousElementSibling;
    btn.addEventListener('click', function () {
      var open = body.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
    btn.setAttribute('data-more', btn.textContent); btn.setAttribute('data-less', btn.getAttribute('data-less-label') || 'Show less');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-mentions"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rail = document.querySelector('[data-proof-rail]'); var nav = document.querySelector('[data-proof-nav]');
  if (!rail || !nav) return;
  var cards = Array.prototype.slice.call(rail.children); if (cards.length < 2) return;
  var prev = nav.querySelector('[data-proof-prev]'), next = nav.querySelector('[data-proof-next]'), count = nav.querySelector('[data-proof-count]');
  var mq = window.matchMedia('(max-width: 767px)');
  var index = function () { var x = rail.scrollLeft, best = 0, d = Infinity; cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - rail.offsetLeft - x); if (dd < d) { d = dd; best = i; } }); return best; };
  var sync = function () { var i = index(); count.textContent = (i + 1) + ' / ' + cards.length; prev.disabled = i === 0; next.disabled = i === cards.length - 1; };
  var go = function (i) { i = Math.max(0, Math.min(cards.length - 1, i)); var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; rail.scrollTo({ left: cards[i].offsetLeft - rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); };
  prev.addEventListener('click', function () { go(index() - 1); }); next.addEventListener('click', function () { go(index() + 1); });
  var raf; rail.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
  rail.addEventListener('focusin', function (e) { var card = e.target.closest('.proof-card'); if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
  var apply = function () { if (mq.matches) { nav.removeAttribute('hidden'); sync(); } else { nav.setAttribute('hidden', ''); } };
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply); apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-sticky-cta]'); if (!bar) return;
  var hero = document.querySelector('[data-sticky-trigger]') || document.querySelector('.hero-cta') || document.querySelector('.hero') || document.querySelector('.jumpnav');
  var enders = document.querySelectorAll('.band, footer'); if (!hero) return;
  var heroGone = false, endVisible = false;
  var apply = function () { var on = heroGone && !endVisible && window.matchMedia('(max-width: 989px)').matches; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); };
  new IntersectionObserver(function (es) { heroGone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; apply(); }).observe(hero);
  var endIO = new IntersectionObserver(function (es) { endVisible = es.some(function (e) { return e.isIntersecting; }) || Array.prototype.some.call(enders, function (el) { var r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; }); apply(); }, { threshold: 0 });
  enders.forEach(function (el) { endIO.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-landing-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(gallery) {
    if (gallery.dataset.galleryReady) return;
    var viewport = gallery.querySelector('[data-gallery-viewport]');
    if (!viewport) return;
    gallery.dataset.galleryReady = 'true';
    var slides = Array.from(viewport.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    var strip = gallery.querySelector('[data-gallery-thumbnails]');
    var previous = gallery.querySelector('[data-gallery-previous]');
    var next = gallery.querySelector('[data-gallery-next]');
    var position = gallery.querySelector('[data-gallery-position]');
    var active = -1, frame = 0;
    function sync() {
      frame = 0;
      var width = viewport.clientWidth;
      if (!width) return;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / width)));
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (index === active) return;
      active = index;
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === index)); });
      if (position) position.textContent = gallery.dataset.galleryCountPattern.replace('__CURRENT__', String(index + 1));
      var thumb = thumbs[index];
      if (strip && thumb) {
        var t = thumb.getBoundingClientRect(), r = strip.getBoundingClientRect();
        if (t.left < r.left || t.right > r.right) strip.scrollTo({left: strip.scrollLeft + t.left - r.left - (r.width - t.width) / 2, behavior: 'auto'});
      }
    }
    function go(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      viewport.scrollTo({left: index * viewport.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function (event) { event.preventDefault(); go(i); }); });
    if (previous) { previous.hidden = false; previous.addEventListener('click', function () { go(active - 1); }); }
    if (next) { next.hidden = false; next.addEventListener('click', function () { go(active + 1); }); }
    viewport.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(sync); }, {passive:true});
    viewport.addEventListener('keydown', function (event) {
      if (event.target !== viewport) return;
      var index;
      if (event.key === 'ArrowRight') index = active + 1;
      else if (event.key === 'ArrowLeft') index = active - 1;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = slides.length - 1;
      else return;
      event.preventDefault(); go(index);
    });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (active >= 0) viewport.scrollTo({left: active * viewport.clientWidth, behavior:'instant'}); sync(); }).observe(viewport);
    sync();
  }
  function init(root) {
    root.querySelectorAll('[data-watch-gallery]').forEach(initGallery);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
